import React from 'react';
import PropTypes from 'prop-types';
// import './NoRecord.css';

const NoRecord = ({ noDataText }:any) => {
  return (
    <div className="aligncntr">
      <div>
          <i style={{ fontSize: '30px' }} className="nc-icon nc-alert-circle-i"></i>
          <h4>{noDataText}</h4>
      </div>
    </div>
  );
};

NoRecord.propTypes = {
  noDataText: PropTypes.string,
};

NoRecord.defaultProps = {
  noDataText: 'No records found',
};

export default NoRecord;
